import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomSwitch, {atomSwitchDesigns, atomSwitchSizes} from '@s-ui/react-atom-switch'
import Context from '@s-ui/react-context'

const BASE_CLASS = 'mt-userProfileEdit-formUserPersonalData-switchHidePhone'

const FormUserPersonalDataSwitchHidePhone = ({id, innerProps: {checked, onToggle, ...props}}) => {
  const {domain, i18n} = useContext(Context)
  const APP_NAME = domain.get('config').get('APP_NAME')

  return (
    <div className={`${BASE_CLASS}Wrapper`}>
      <div className={BASE_CLASS}>
        <AtomSwitch
          checked={checked}
          design={atomSwitchDesigns.SINGLE}
          id={id}
          onToggle={onToggle}
          size={atomSwitchSizes.LARGE}
        />
        <label htmlFor={id} className={`${BASE_CLASS}Label`}>
          {i18n.t(`PUBLISH_AD.USER_INFO.HIDE_PHONE_CHECKBOX_LABEL.${APP_NAME}`)}
        </label>
      </div>
      <p className={`${BASE_CLASS}LabelHelpText`}>{i18n.t('USER_PROFILE.EDIT.HIDE_PHONE_HELP_TEXT')}</p>
    </div>
  )
}

FormUserPersonalDataSwitchHidePhone.displayName = 'FormUserPersonalDataSwitchHidePhone'

FormUserPersonalDataSwitchHidePhone.propTypes = {
  id: PropTypes.string.isRequired,
  innerProps: PropTypes.shape({
    checked: PropTypes.bool,
    onToggle: PropTypes.func.isRequired
  }).isRequired
}

export default FormUserPersonalDataSwitchHidePhone
